import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-100 mt-12">
      <div className="max-w-7xl mx-auto px-6 py-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <h2 className="text-lg font-semibold text-white mb-2">📍 Jivan Jyoti Trust</h2>
          <p className="text-sm">Serving communities in need since 1962</p>
          <p className="text-sm">Ahmedabad, Gujarat, India</p>
        </div>

        <div>
          <h3 className="text-md font-semibold text-white mb-2">📞 Contact</h3>
          <p className="text-sm">Phone: +91 93270 31378</p>
          <p className="text-sm">Email: jivanjyotitrust123@gmail.com</p>
        </div>

        <div>
          <h3 className="text-md font-semibold text-white mb-2">🕒 Office Hours</h3>
          <p className="text-sm">Mon – Sat: 9:00 AM – 5:00 PM</p>
          <p className="text-sm">Sunday: Closed</p>
        </div>
      </div>

      <div className="text-center text-xs text-gray-400 py-4 border-t border-gray-700">
        &copy; {new Date().getFullYear()} Jivan Jyoti Trust. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
